const defaultSettings = {
  acceptRequired: false,
  isAcceptedByDefault: false
};
export const getTermsAndConditionsSettings = clientData => {
  if (!(clientData != null && clientData.termsAndConditionsSettings)) {
    return defaultSettings;
  }
  try {
    const {
      acceptRequired,
      isAcceptedByDefault
    } = JSON.parse(clientData.termsAndConditionsSettings);
    return {
      acceptRequired: acceptRequired != null ? acceptRequired : defaultSettings.acceptRequired,
      isAcceptedByDefault: isAcceptedByDefault != null ? isAcceptedByDefault : defaultSettings.isAcceptedByDefault
    };
  } catch (_unused) {
    return defaultSettings;
  }
};
//# sourceMappingURL=get-terms-and-conditions-settings.js.map